import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '@/constants';

const UnknownErrorPageBody: React.FC = () => {
  return (
    <div>
      <h1>Unknown Error</h1>
      <p>
        An unknown error has occurred. Please try again or contact support if
        the problem persists.
      </p>
      <Link to={PATHS.APPLICANT.DASHBOARD}>Go to Home</Link>
    </div>
  );
};

export default UnknownErrorPageBody;
